enum ClientType {
	Public = 1,
	Volume = 2,
}

enum CheckoutStatusType {
	Pending = 1,
	InProgress = 2,
	CheckedOut = 3,
	Canceled = 5,
	NoShow = 6,
}

enum AppointmentTypes {
	SpayOrNeuter = 1,
	Recheck = 2,
	Wellness = 3,
}

enum TransportStatusType {
	Confirmed = 1,
	Arrived = 2,
	Departed = 3,
}

enum LobbyStatus {
	Pending = 1,
	Arrived = 2,
	CheckedIn = 3,
	ReadyForPickup = 4,
	Departed = 5,
}

enum AnimalTypes {
	Owned = 1,
	Shelter = 2,
	Foster = 3,
	CommunityCatFeral = 4,
	CommunityCatFriendly = 5,
	Misc1 = 6,
	Misc2 = 7,
	Misc3 = 8,
}

enum GenderTypes {
	Male = 1,
	Female = 2,
}

enum PaymentTypes {
	Cash = 1,
	Check = 2,
	CreditCard = 3,
	WriteOff = 4,
	ClientCredit = 5,
	Grant = 6,
}

enum PaymentActions {
	Direct = 0,
	Refund = 1,
	Deposit = 2,
	Overpayment = 3,
}

enum PaymentOriginType {
	Appointment = 1,
	ClientCredit = 2,
	Grant = 3,
	Subsidy = 4,
	Sale = 5,
	Invoice = 6,
}

enum IntegratedPaymentTypes {
	Online = 1,
	POS = 2,
}

enum RepurposeOption {
	Donation = 0,
	ClientCredit = 1,
}

enum DepositType {
	Deposits = 1,
	Forfeited = 2,
	Credited = 3,
	Refunded = 4,
	UnmatchedDeposits = 5,
}

enum PosProviderTypes {
	Dejavoo = 2,
}

enum ItemTypes {
	Service = 2,
	Product = 3,
	Surgery = 4,
	Vaccine = 5,
	ItemSale = 6,
}

enum MessageTypes {
	System = 0,
	AppointmentConfirmation = 1,
	AppointmentReminder = 2,
	ItemReminder = 3,
	TextForPickup = 4,
	ConsentReminder = 11,
	PaymentRequest = 21,
	PaymentReceipt = 22,
	AftercarePaperwork = 31,
	MedicalRecord = 32,
}

enum ReminderTypes {
	Confirmation = 1,
	Appointment = 2,
	Item = 3,
	Consent = 4,
	TextForPickup = 5,
}

enum DeliveryTypes {
	Call = 1,
	Sms = 2,
	Email = 3,
}

enum DateIntervals {
	Day = 1,
	Week = 2,
	Month = 3,
	Year = 4,
}

enum PaperworkSelection {
	SpayOrNeuter = 1,
	RabiesCertificate = 2,
	Receipt = 3,
}

enum PaperworkSortOrder {
	Alphabetic = 1,
	AnimalName = 2,
	AnimalNumber = 3,
	RabiesTag = 4,
	AppointmentTime = 5,
}

enum ClientSearchEnum {
	Name = 1,
	CellPhone = 2,
	HomePhone = 3,
	Address = 4,
}

enum ClientSearchType {
	PublicClient = 1,
	VolumeClient = 2,
	AnimalOwner = 3,
	AnimalByID = 4,
	Microchip = 6,
	RabiesTag = 7,
	AnimalOwnerLastName = 8,
}

enum OnlineDepositType {
	NoDeposits = 0,
	DepositFixed = 1,
	DepositBySpecies = 2,
	DepositByServices = 3,
}

enum OnlineDocumentUploadType {
	DocumentsDisabled = 0,
	DocumentsOptional = 1,
	DocumentsRequired = 2,
}

enum DocumentStatus {
	Assigned = 1,
	Opened = 2,
	Signed = 3,
	Declined = 4,
	RequestedOnPaper = 5,
	Canceled = 6,
}

enum RabiesTagType {
	OneYear = 1,
	ThreeYear = 3,
}

enum AutoResponderTypes {
	NoText = 1,
	CustomMessage = 2,
	AutoResponder = 3,
}

enum AuditAction {
	Delete = 1,
	Update = 2,
	Merge = 5,
}

enum AuditOriginType {
	Appointment = 1,
	Animal = 2,
	Client = 3,
	Invoice = 4,
	Clinic = 5,
	DrugBottle = 6,
	Subscription = 7,
}

enum GrantTypes {
	Prepaid = 2,
	Invoiced = 3,
}

enum TechniqueTypes {
	ClosedCastration = 1,
	OpenCastration = 2,
}

enum SutureTechniques {
	SimpleContinuous = 1,
	SimpleInterrupted = 2,
	Transfixation = 3,
	InstrumentTie = 4,
	Circumferential = 5,
	StrangleKnot = 6,
	Cruciate = 7,
	SubcuticularMattress = 8,
	SubcuticularPattern = 9,
	SurgicalGlue = 10,
	Staples = 11,
	Subcuticular = 12,
	MillersKnot = 13,
	AutoLigation = 14,
	ScrotalTack = 15,
	None = 16,
	DoubleLigation = 17,
	FordInterlocking = 18,
}

enum ScrotalTypes {
	AdultScrotal = 1,
	AdultPreScrotal = 2,
	PediatricScrotal = 3,
}

enum SkinIncisionTypes {
	PreScrotal = 1,
	Scrotal = 2,
}

enum TechniqueFemaleTypes {
	OVE = 1,
	OVH = 2,
	OVESubtotalHysterectomy = 3,
	OVEPartialHysterectomy = 4,
}

enum SplashBlockTypes {
	Bupivacaine = 1,
	DilutePhenylephrine = 2,
	Lidocaine = 3,
	BupivacaineDexmedetomidine = 4,
}

enum VetProfileType {
	AdultScrotal = 11,
	AdultPreScrotal = 12,
	PediatricScrotal = 13,
	Pregnant = 21,
}

enum SurgicalConditionTypes {
	IsCryptorchid = 11,
	IsInHeat = 21,
	IsPregnant = 22,
	Postpartum = 23,
	Lactating = 24,
	Fatty = 25,
	Friable = 26,
}

enum SurgeryStatusType {
	ExamAndPreMed = 1,
	DrugDraw = 2,
	Surgery = 3,
	PostOp = 4,
}

enum DrugActionType {
	Drawn = 1,
	Given = 2,
	Wasted = 3,
}

enum AssessmentType {
	Yes = 1,
	No = 2,
}

enum SubjectiveType {
	BAR = 1,
	ABN = 2,
}

enum ObjectiveType {
	NRM = 1,
	ABN = 2,
	CouldNotExam = 3,
}

enum PlanType {
	Accept = 1,
	Decline = 2,
}

enum TPRType {
	WNL = 1,
	ABN = 2,
}

enum AgeType {
	Adult = 1,
	Pediatric = 2,
}

enum SpayedNeuteredType {
	No = 0,
	Yes = 1,
	Unknown = 2,
	DidNotAsk = 3,
}

enum DrugPhase {
	PreMed = 1,
	Induction = 2,
	PostOp = 3,
	Other = 4,
	Surgery = 5,
	Emergency = 6,
	Reversal = 7,
}

enum OriginType {
	ItemTriggered = 1,
	DeclinedSurgery = 2,
	Prescription = 3,
	Drugs = 4,
	DeclinedSurgeryDetails = 5,
	HighRiskWaivers = 6,
	HighRiskWaiverBlurbs = 7,
	TestResults = 8,
	SurgicalConditions = 9,
}

enum CustomFieldType {
	DropdownList = 1,
	Checkbox = 2,
	Textbox = 3,
	MultilineTextbox = 4,
	MultipleSelect = 5,
}

enum HighRiskWaiverType {
	Requested = 1,
	Accepted = 2,
	Declined = 3,
	OwnerUnreachable = 4,
	Cancel = 5,
}

enum DrugRouteType {
	SQorIM = 1,
	SQOnly = 2,
	IV = 3,
	Oral = 4,
	IMOnly = 5,
	IVorIM = 6,
	Transdermal = 7,
	Topical = 8,
	IntraTesticular = 9,
	Endotracheal = 10,
	SQorIV = 11,
	IP = 12,
	Rectal = 13,
	Intracardiac = 14,
	Block = 15,
	Intranasal = 16,
}

enum DrugBottleStatus {
	Closed = 0,
	Open = 1,
	Done = 2,
}

enum PatientFlowType {
	Disabled = 0,
	Anesthetic = 1,
	NonAnesthetic = 2,
}

enum PatientFlowTab {
	Exam = 1,
	DrugDraw = 2,
	Declined = 3,
	Rx = 4,
	Hrw = 5,
}

enum FlagType {
	AmTasks = 1,
	ExtendedExam = 2,
	RecheckInPatientFlow = 3,
	BasicWellnessInPatientFlow = 4,
	ExamDefaults = 5,
}

enum TemplateType {
	Consent = 1,
	TakeHomePaperwork = 2,
	HighRiskWaiver = 3,
}

enum DocumentFieldType {
	Signature = 1,
	Text = 2,
	Checkbox = 3,
	Date = 4,
}

enum NoteTypes {
	Appointment = 1,
	Animal = 2,
	Client = 3,
	Team = 4,
}

enum RecheckOutcome {
	SurgicalComplication = 1,
	ServiceComplication = 2,
	NonComplianceComplication = 3,
	Unknown = 4,
}

enum VetTypes {
	Clinic = 1,
	NSNRT = 2,
	Private = 3,
	Extern = 4,
	Relief = 5,
	Admin = 6,
	Off = 7,
	NTrav = 8,
	Workshop = 9,
	TrainingCenter = 10,
	Shadowing = 11,
	Misc = 12,
	InTraining = 13,
}

enum DoneActionType {
	CheckoutAnimal = 0,
	EmailTextClient = 1,
	PrintPaperwork = 2,
	EmailPaperwork = 3,
	TextReady = 4,
	SdrOnly = 5,
	EmailTextVCO = 6,
}

enum ReminderRecipientTypes {
	CurrentOwner = 0,
	PublicClient = 1,
	VolumeClient = 2,
	VolumeVcpClient = 3,
	VolumeNonVcpClient = 4,
	VolumeClientOwner = 5,
}

enum SpecieType {
	Dog = 1,
	Cat = 2,
}

enum DonationType {
	General = 1,
	Basic = 2,
	InMemoriam = 3,
	Fundraiser = 4,
}

enum DonationSource {
	Person = 1,
	Organization = 2,
}

enum StatusTypes {
	Disabled = 0,
	Active = 1,
	Deleted = 2,
}

enum InvoiceStatus {
	Open = 1,
	Paid = 2,
}

enum RestrictionType {
	Species = 0,
	Breed = 1,
	Sex = 2,
	Zip = 3,
	County = 4,
	City = 5,
	CustomField = 6,
}

enum PetSmartTypes {
	DoctorVisits = 1,
	EmergencyVisits = 2,
	SurgeryVisits = 3,
	DentalVisits = 4,
	PharmacyPickup = 5,
	TechVisits = 6,
}

enum AnimalOwnerTypes {
	Owner = 1,
	Foster = 2,
	ColonyCareTaker = 3,
}

enum ShelterType {
	Shelterluv = 1,
	PetPoint = 2,
}

enum DonationFeeType {
	None = 0,
	Fixed = 1,
	Percentage = 2,
}

enum SubscriptionStatus {
	Pending = 0,
	Active = 1,
	PastDue = 2,
	Suspended = 3,
}

enum LeadType {
	Direct = 1,
	Demo = 2,
	Converted = 3,
	NonLead = -1,
}

enum TestTypes {
	MaleFemale = 0,
	PositiveNegative = 1,
	PositiveNegative2 = 2,
	PositiveNegative3 = 3,
	PositiveNegative4 = 4,
	ParasitesSeen = 5,
	PassFail = 6,
	NormalAbnormal = 7,
}

export default {
	ClientType,
	CheckoutStatusType,
	AppointmentTypes,
	TransportStatusType,
	LobbyStatus,
	AnimalTypes,
	GenderTypes,
	PaymentTypes,
	PaymentActions,
	PaymentOriginType,
	IntegratedPaymentTypes,
	RepurposeOption,
	DepositType,
	PosProviderTypes,
	ItemTypes,
	MessageTypes,
	ReminderTypes,
	DeliveryTypes,
	DateIntervals,
	PaperworkSelection,
	PaperworkSortOrder,
	ClientSearchEnum,
	ClientSearchType,
	OnlineDepositType,
	OnlineDocumentUploadType,
	DocumentStatus,
	RabiesTagType,
	AutoResponderTypes,
	AuditAction,
	AuditOriginType,
	GrantTypes,
	TechniqueTypes,
	SutureTechniques,
	ScrotalTypes,
	SkinIncisionTypes,
	TechniqueFemaleTypes,
	SplashBlockTypes,
	VetProfileType,
	SurgicalConditionTypes,
	SurgeryStatusType,
	DrugActionType,
	AssessmentType,
	SubjectiveType,
	ObjectiveType,
	PlanType,
	TPRType,
	AgeType,
	SpayedNeuteredType,
	DrugPhase,
	OriginType,
	CustomFieldType,
	HighRiskWaiverType,
	DrugRouteType,
	DrugBottleStatus,
	PatientFlowType,
	PatientFlowTab,
	FlagType,
	TemplateType,
	DocumentFieldType,
	NoteTypes,
	RecheckOutcome,
	VetTypes,
	DoneActionType,
	ReminderRecipientTypes,
	SpecieType,
	DonationType,
	DonationSource,
	StatusTypes,
	InvoiceStatus,
	RestrictionType,
	PetSmartTypes,
	AnimalOwnerTypes,
	ShelterType,
	DonationFeeType,
	SubscriptionStatus,
	LeadType,
	TestTypes,
}
